export const SHARED_FIELDS = [
  {
    name: 'nickname',
    label: 'Nickname',
    tooltip: null,
    type: 'textfield',
    isMeta: true,
  },
]
